<template>
    <div>
        <div class="page-container">
            <v-page-header
                title="批量导入新员工"
                :back="{
                    title: '组织架构',
                    goBack,
                }"
            />
            <div v-show="showResult">
                <div v-if="failPeople === 0" class="page_result_success"></div>
                <div v-else-if="successPeople > 0 && failPeople > 0" class="page_result_problem"></div>
                <div v-else-if="successPeople === 0" class="page_result_fail"></div>
                <div v-if="failPeople === 0" class="page_text">
                    <span>{{ successPeople }}</span>
                    人全部导入成功
                </div>
                <div v-if="failPeople > 0" class="page_text">
                    导入成功<span class="export_success">{{ successPeople }}</span
                    >人, 失败<span class="export_fail">{{ failPeople }}</span
                    >人
                </div>
                <div v-if="failPeople > 0" class="export_middle_text">
                    <span>{{ failMsg }}</span>
                </div>

                <!-- <div v-if="successPeople === 0">
                    可能导致导入失败的原因：1、必填字段缺失；2、账号名重复；3、填写内容不规范；4、手机号重复
                </div>
                <div v-if="importfail">
                    可能导致导入失败的原因：填写内容不规范
                </div>
                <div v-if="importfail">
                    请减少要导入的员工数：需要更多账号，请联系经销商（上海国经 400-783-092）购买
                </div>-->

                <div class="page_botton">
                    <v-button v-if="failPeople === 0" status="primary" size="large" @click="successBtn">完成</v-button>
                    <v-button
                        v-if="failPeople > 0"
                        class="botton_left"
                        status="primary"
                        size="large"
                        @click="downFailList"
                        >下载失败列表</v-button
                    >
                    <v-button
                        v-if="successPeople > 0 || failPeople > 0"
                        class="botton_left"
                        status="default"
                        size="large"
                        @click="goToExportPage"
                        >继续导入新员工</v-button
                    >
                    <v-button
                        v-if="successPeople === 0 && failPeople === 0"
                        class="botton_left"
                        size="large"
                        @click="goToUploadPage"
                        >重新上传文件</v-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable prefer-destructuring */

import { Icon } from 'vhtml-ui';
import { envDomain } from '@/utils/domainConfig';

const req = require.context('@/assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    data() {
        return {
            successPeople: 0,
            failPeople: 0,
            failMsg: '可能导致导入失败的原因：1、必填字段缺失；2、账号名重复；3、填写内容不规范；4、手机号重复',
            checkStatusUrl: envDomain.gateway + '/v1/mng/org/importExportCheckStatus?taskType=0',
            showResult: false,
            downloadErrorListUrl: ''
            // checkStatusUrl: '/v1/mng/org/indexImportExportStatus?taskType=0'
        };
    },
    computed: {},
    mounted() {
        this.getExportStatus();
    },
    methods: {
        goBack() {
            window.location.href = '/mng/org';
        },
        getExportStatus() {
            this.importExportCheckStatus()
                .then(data => {
                    this.downloadErrorListUrl = data.data.result_file_url;
                    this.successPeople = data.data.successNum;
                    this.failPeople = data.data.failedNum;
                    this.failMsg = data.message;
                    this.showResult = true;
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        },
        importExportCheckStatus() {
            return new Promise((resolve, reject) => {
                this.$ajax
                    .crossGet(this.checkStatusUrl)
                    .then(data => {
                        if (data && data.code === 0) {
                            resolve(data);
                        } else {
                            reject(new Error(data.msg));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        successBtn() {
            window.location.href = '/mng/org';
        },
        downFailList() {
            window.open(this.downloadErrorListUrl);
        },
        goToExportPage() {
            window.location.href = '/mng/org/importMembersExport';
        },
        goToUploadPage() {
            window.location.href = '/mng/org/importMembersExport';
        }
    }
};
</script>

<style lang="less">
@import '../styles/app';
</style>
